import React from "react";
import { Check } from "lucide-react";

const FLOW = ["Received", "On route", "Completed"];

export function OrderTimeline({ status, history }) {
  if (status === "Cancelled" || status === "On hold") {
    return (
      <div className="flex items-center gap-2">
        <span className={`w-3 h-3 rounded-full ${status === "Cancelled" ? "bg-sambiva-red" : "bg-orange-500"}`} />
        <span className="font-semibold text-sambiva-charcoal">{status}</span>
      </div>
    );
  }
  const currentIdx = FLOW.indexOf(status);
  const tsFor = (s) => history?.find((h) => h.status === s)?.timestamp;
  return (
    <div className="flex items-center" data-testid="order-timeline">
      {FLOW.map((s, i) => {
        const done = i <= currentIdx;
        return (
          <React.Fragment key={s}>
            <div className="flex flex-col items-center">
              <div className={`w-9 h-9 rounded-full flex items-center justify-center ${done ? "bg-sambiva-green text-white" : "bg-sambiva-charcoal/10 text-sambiva-muted"}`}>
                {done ? <Check size={18} /> : i + 1}
              </div>
              <span className={`text-xs mt-2 font-medium ${done ? "text-sambiva-charcoal" : "text-sambiva-muted"}`}>{s}</span>
              {tsFor(s) && <span className="text-[10px] text-sambiva-muted">{new Date(tsFor(s)).toLocaleDateString()}</span>}
            </div>
            {i < FLOW.length - 1 && <div className={`flex-1 h-0.5 mx-1 mb-6 ${i < currentIdx ? "bg-sambiva-green" : "bg-sambiva-charcoal/10"}`} />}
          </React.Fragment>
        );
      })}
    </div>
  );
}
